import React from "react";
import { getToken, logout, setAuthHandoffToken } from "../../services/auth";
import { getUsername } from "../../services/auth";
import QuickPatientSearch, { PatientSearchItem } from "./QuickPatientSearch";
import ModuleShellHeader from "../common/ModuleShellHeader";
import type { AlertBadge } from "../common/ModuleShellHeader";
import { useI18n } from "../../i18n/I18nProvider";
// Legacy CSS kept so existing overrides still apply
import "./ReceptionModuleHeader.css";

interface ReceptionModuleHeaderProps {
    onPatientSelect?: (_patient: PatientSearchItem) => void;
    onEdit?: (p: PatientSearchItem) => void;
    pendingRecallsCount?: number;
    onToggleRecalls?: () => void;
    pendingOnlineAppointmentsCount?: number;
    onToggleOnlineAppointments?: () => void;
}

export default function ReceptionModuleHeader({
    onPatientSelect,
    onEdit,
    pendingRecallsCount = 0,
    onToggleRecalls,
    pendingOnlineAppointmentsCount = 0,
    onToggleOnlineAppointments,
}: ReceptionModuleHeaderProps) {
    const { t } = useI18n();
    const openPharmacy = () => {
        const token = getToken();
        if (token) setAuthHandoffToken(token);
        window.open("/pharmacy", "_blank", "noopener,noreferrer");
    };

    const username = getUsername() || t("reception_role_front_desk");

    const alerts: AlertBadge[] = [
        ...(onToggleRecalls ? [{
            key: "recalls",
            label: t("reception_alert_recalls"),
            count: pendingRecallsCount,
            icon: "recall" as const,
            badgeColor: pendingRecallsCount > 0 ? "#f59e0b" : undefined,
            onClick: onToggleRecalls,
        }] : []),
        ...(onToggleOnlineAppointments ? [{
            key: "online",
            label: t("reception_alert_online"),
            count: pendingOnlineAppointmentsCount,
            icon: "online" as const,
            badgeColor: pendingOnlineAppointmentsCount > 0 ? "#3b82f6" : undefined,
            onClick: onToggleOnlineAppointments,
        }] : []),
    ];

    return (
        <ModuleShellHeader
            theme="reception"
            brandName={t("reception_brand_name")}
            brandSub={t("reception_brand_sub")}
            alerts={alerts}
            user={{ name: username, role: t("reception_role_front_desk") }}
            onLogout={() => { logout(); window.location.href = "/"; }}
            showDate
        >
            {/* Patient search + pharmacy shortcut */}
            <QuickPatientSearch
                onPatientSelect={onPatientSelect}
                onEdit={onEdit}
                placeholder={t("reception_search_patient")}
            />
            <button
                type="button"
                className="rmh-btn-pharmacy"
                onClick={openPharmacy}
                title={t("reception_open_pharmacy")}
            >
                {t("reception_open_pharmacy_label")}
            </button>
        </ModuleShellHeader>
    );
}
